import { HttpClient } from 'api/http-client';
class BillingHttpClient extends HttpClient {
    getSubscription(includeMeta) {
        return this.get(`/subscription${includeMeta ? '?includeMeta=true' : ''}`);
    }
    getInvoiceDetails() {
        return this.get('/subscription/invoice-details');
    }
    getInvoiceList(subscriptionId) {
        return this.get(`/subscription/${subscriptionId}/invoices?limit=10`);
    }
    createPortalSession() {
        return this.post('/subscription/self-serve');
    }
    changePlan(payload) {
        return this.post('/subscription/change-plan', payload);
    }
    changePlanEstimate(payload) {
        return this.post('/subscription/change-plan?estimate=true', payload);
    }
    addLicences(count) {
        return this.post(`/subscription/add-licences/${count}`);
    }
    addLicenceAddon(count, addonIdentifier) {
        return this.post(`/subscription/add-addons/${addonIdentifier}?count=${count}`);
    }
    addLicencesEstimate(count) {
        return this.post(`/subscription/add-licences/${count}?estimate=true`);
    }
    addLicenceAddonEstimate(count, addonIdentifier) {
        return this.post(`/subscription/add-addons/${addonIdentifier}?${count > 0 ? `count=${count}&` : ''}estimate=true`);
    }
    addMembers(payload) {
        const { addonIdentifier } = payload;
        return this.post(`/subscription/add-agents?${addonIdentifier ? `addons=${addonIdentifier}` : ''}`, payload.data);
    }
    addMembersAddon(data, addonIdentifier) {
        return this.put(`/subscription/add-addon-agents/${addonIdentifier}`, [
            {
                user: data
            }
        ]);
    }
    estimateAddMembersAddon(data, addonIdentifier) {
        return this.put(`/subscription/add-addon-agents/${addonIdentifier}?estimate=true`, [
            {
                user: data
            }
        ]);
    }
    addMembersEstimate(payload) {
        const { addonIdentifier } = payload;
        return this.post(`/subscription/add-agents?estimate=true${addonIdentifier ? `&addons=${addonIdentifier}` : ''}`, payload.data);
    }
    addPartnerMembersAndInviteToProject(payload, projectId) {
        return this.post(`/subscription/add-partner-agents?projectId=${projectId}`, payload);
    }
    addPartnerMembers(payload) {
        return this.post('/subscription/add-partner-agents', payload);
    }
    addPartnerMembersEstimate(payload) {
        return this.post('/subscription/add-partner-agents?estimate=true', payload.data);
    }
    changePlanCheckout(payload) {
        return this.post('/subscription/change-plan-checkout', payload);
    }
    getAddonUsageDetails({ feature }) {
        return this.get(`/feature-usage/${feature}`);
    }
    changeAddonCheckout(count, addonIdentifier) {
        const payload = {
            units: count
        };
        return this.post(`/subscription/change-addon-checkout/${addonIdentifier}`, payload);
    }
    reactivationCheckout(payload) {
        return this.post('/subscription/change-plan-checkout?reactivate=true', payload);
    }
    removeScheduledPlanChange() {
        return this.post('/subscription/remove-plan-changes');
    }
    scheduleSubscriptionCancellation(formValues) {
        return this.post('/subscription/schedule-cancellation', formValues);
    }
    removeScheduledCancellation() {
        return this.post('/subscription/remove-cancellation');
    }
    updateInvoiceDetails(payload) {
        return this.post('/subscription/invoice-details', payload);
    }
    downloadInvoice(subscriptionId, invoiceId) {
        return this.get(`subscription/${subscriptionId}/invoice/${invoiceId}/download`);
    }
    forceSyncSubscription(subscriptionId) {
        return this.post(`/subscription/${subscriptionId}/force-sync`);
    }
    reactivateMember(userId) {
        return this.post(`/subscription/activate-member/${userId}`);
    }
    reactivateMemberEstimate(userId) {
        return this.post(`/subscription/activate-member/${userId}?estimate=true`);
    }
    reactivatePartnerMember(userId) {
        return this.post(`/subscription/activate-partner-member/${userId}`);
    }
    reactivatePartnerMemberEstimate(userId) {
        return this.post(`/subscription/activate-partner-member/${userId}?estimate=true`);
    }
}
export const BillingAPI = new BillingHttpClient();
